import { useState } from 'react';

const faqItems = [
  {
    q: '桃子影院真的完全免费吗？',
    a: '是的，桃子影院坚持永久免费策略。所有电影、电视剧、综艺、动漫和纪录片均免费在线观看，无需充值会员、无需付费点播。我们通过广告合作维持平台运营，确保内容对全体用户开放。',
  },
  {
    q: '播放画质能达到什么水平？是否需要缓冲？',
    a: '平台支持标清、高清、超清、蓝光及4K多种画质选择，默认推荐超清画质。依托全球CDN加速节点与P2P分发技术，绝大多数影片可实现秒开播放，无需等待缓冲。建议在网络环境良好的情况下选择4K画质以获得最佳观影体验。',
  },
  {
    q: '更新频率如何？能看最新上映的电影吗？',
    a: '桃子影院每日凌晨自动更新片库，热播电视剧同步各大平台当日更新，院线电影在下映后第一时间上线高清版本。部分热门影片还提供超前点映资源，让您足不出户尽享最新影视内容。',
  },
  {
    q: '支持哪些设备观看？需要下载软件吗？',
    a: '桃子影院全面支持PC端浏览器、平板、手机网页端直接观看，无需下载任何软件或插件。同时提供安卓与iOS客户端APP，下载后可享受离线缓存、画质记忆等专属功能，随时随地畅享高清影视。',
  },
  {
    q: '资源是否安全？会不会有弹窗广告影响体验？',
    a: '桃子影院所有资源均经过安全审核，不含恶意代码和强制弹窗。我们采用绿色广告策略，页面广告位置固定、不影响观影体验。同时，平台严格遵守内容合规要求，确保所有上架内容符合法律法规。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="relative py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-400 bg-secondary-500/10 rounded-full mb-4">
            常见问答
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            关于桃子影院的常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-2xl mx-auto">
            快速了解桃子影院的使用方式与特色功能
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-200/60 rounded-xl border border-background-300/20 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/80 transition-colors"
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-100 pr-4">
                  {item.q}
                </h3>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-transform duration-300 ${openIndex === index ? 'rotate-180 bg-primary-500/20 text-primary-400' : 'bg-background-300/50 text-foreground-400'}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4">
                  <div className="w-full h-px bg-background-300/30 mb-4"></div>
                  <p className="text-sm text-foreground-400 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}